import {
    FunctionComponent,
    ReactNode,
    useCallback,
    useEffect,
    useState
} from 'react';
import {
    AuthUser,
    fetchAuthSession,
    getCurrentUser,
    JWT
} from 'aws-amplify/auth';
import {AuthContext} from '../context/AuthContext';

interface IAuthProvider {
    children?: ReactNode
}

export const AuthProvider: FunctionComponent<IAuthProvider> = ({children}) => {

    const [loading, setLoading] = useState(true)
    const [user, setUser] = useState<AuthUser | undefined>();
    const [idToken, setIdToken] = useState<JWT | undefined>();
    const [accessToken, setAccessToken] = useState<JWT | undefined>();
    const [cognitoGroups, setCognitoGroups] = useState<string[] | undefined>();
    const [role, setRole] = useState<string | undefined>();

    const fetchCognitoUser = useCallback(async () => {

        try {
            const cognitoUser = await getCurrentUser()
            setUser(cognitoUser)
        } catch (error) {
            console.trace(
                'AUTH CONTEXT. FETCH USER ERROR',
                error
            );
        }

    }, []);

    const fetchSession = async () => {

        try {
            const {
                accessToken,
                idToken
            } = (await fetchAuthSession()).tokens ?? {};

            setIdToken(idToken);
            setAccessToken(accessToken);

            if (typeof idToken !== 'undefined'
                && idToken.payload['cognito:groups'] !== undefined
                && Array.isArray(idToken.payload['cognito:groups'])
                && idToken.payload['cognito:groups'].length > 0) {

                setCognitoGroups(idToken.payload['cognito:groups'] as string[]);

            }

            // if (accessToken && idToken) {
            //     const cognitoAuthTokens = await refreshAuthTokens();
            //     console.debug('cognitoAuthTokens', cognitoAuthTokens)
            // }

        } catch (error) {
            console.trace(
                'AUTH CONTEXT. FETCH SESSION ERROR',
                error
            );
        } finally {
            setLoading(false);
        }

    };

    useEffect(() => {
        fetchCognitoUser();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);


    useEffect(() => {
        fetchSession();
    }, []);


    useEffect(() => {

        setRole('User')

        if (typeof idToken !== 'undefined'
            && idToken.payload['cognito:groups'] !== undefined
            && Array.isArray(idToken.payload['cognito:groups'])
            && idToken.payload['cognito:groups'].length > 0) {

            const managedUserItem = idToken.payload['cognito:groups'].find((item: unknown) => item === 'managed_user')
            if (managedUserItem) {
                setRole('ManagedUser')
            }

            const orgAdminItem = idToken.payload['cognito:groups'].find((item: unknown) => item === 'org_admin')
            if (orgAdminItem) {
                setRole('OrgAdmin')
            }

            const adminItem = idToken.payload['cognito:groups'].find((item: unknown) => item === 'admin')
            if (adminItem) {
                setRole('Admin')
            }

        }

    }, [idToken])


    return (
        <AuthContext.Provider value={{
            loading,
            user,
            idToken,
            accessToken,
            cognitoGroups,
            role,
        }}>
            {children}
        </AuthContext.Provider>
    );
};
